import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const Testimonial = () => {


  /* Testimonial */
  const indicatorStyles = {
    background: 'blue',
    width: 18,
    height: 18,
    display: 'inline-block',
    margin: '0 12px 0px'
  }
  const testimonialCarouselsettings = {
    autoPlay:true,
    showThumbs:false,
    showStatus:false,
    showIndicator:true
  }
  /* end */ 


  return (
    <>
      {/*==========================
    Clients Section
  ============================*/}
      <section id="testimonials" className="section-bg">
        <div className="container">
          <header className="section-header">
            <h3>Testimonials</h3>
          </header>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="owl-carousel testimonials-carousel wow fadeInUp">
                <Carousel
                  {...testimonialCarouselsettings}
                  renderIndicator={(
                    onClickHandler,
                    isSelected,
                    index,
                    label
                  ) => {
                    if (isSelected) {
                      return (
                        <li
                          style={{ ...indicatorStyles, background: "#000" }}
                          aria-label={`Selected: ${label} ${index + 1}`}
                          title={`Selected: ${label} ${index + 1}`}
                        />
                      );
                    }
                    return (
                      <li
                        style={indicatorStyles}
                        onClick={onClickHandler}
                        onKeyDown={onClickHandler}
                        value={index}
                        key={index}
                        role="button"
                        tabIndex={0}
                        title={`${label} ${index + 1}`}
                        aria-label={`${label} ${index + 1}`}
                      />
                    );
                  }}
                >
                  <div className="testimonial-item text-left">
                    <img
                      src="img/testimonial/nadeem-quazi.jpeg"
                      className="testimonial-img"
                      alt=""
                    />
                    <h3>Nadeem Quazi</h3>
                    <h4>CEO &amp; Founder</h4>
                    <p>
                      Working with MicroVision Infotech was an absolute
                      pleasure. They successfully completed our company's web
                      and mobile app projects with exceptional skill and
                      professionalism. The quality of their work exceeded our
                      expectations, and their attention to detail was
                      impressive. We highly recommend MicroVision Infotech for
                      their reliable and top-notch software services.
                    </p>
                  </div>

                  <div className="testimonial-item text-left">
                    <img
                      src="img/testimonial/aman-khan.jpeg"
                      className="testimonial-img"
                      alt=""
                    />
                    <h3>Aman Ullah Khan</h3>
                    <h4>Director</h4>
                    <p>
                      MicroVision Infotech exceeded our expectations with their
                      software development skills for our website. We would like
                      to refer them for websites and other software and app
                      requirements.
                    </p>
                  </div>
                  {/*   
            <div className="testimonial-item text-left">
              <img src="img/testimonial-3.jpg" className="testimonial-img" alt=""/>
              <h3>Jena Karlis</h3>
              <h4>Store Owner</h4>
              <p>
                Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.
              </p>
            </div>
  
            <div className="testimonial-item text-left">
              <img src="img/testimonial-4.jpg" className="testimonial-img" alt=""/>
              <h3>Matt Brandon</h3>
              <h4>Freelancer</h4>
              <p>
                Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.
              </p>
            </div>
  
            <div className="testimonial-item text-left">
              <img src="img/testimonial-5.jpg" className="testimonial-img" alt=""/>
              <h3>John Larson</h3>
              <h4>Entrepreneur</h4>
              <p>
                Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.
              </p>
            </div> */}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* #testimonials */}
    </>
  );
};

export default Testimonial;